/**
 * Shared date-range label for transaction cards. Collapses same-day
 * ranges to a single date — quote (negotiation) transactions carry one
 * event date (useTransactionCardData sets start = end), and "Jul 16-16"
 * reads like a bug.
 */
export const formatCardDateRange = (intl, startDate, endDate) => {
  if (!startDate || !endDate) return '';
  const startLabel = intl.formatDate(startDate, { month: 'short', day: 'numeric' });
  const sameDay = startDate.toDateString() === endDate.toDateString();
  return sameDay
    ? startLabel
    : `${startLabel}-${intl.formatDate(endDate, { day: 'numeric' })}`;
};

export default formatCardDateRange;
